import React from 'react';
import { NavLink } from 'react-router-dom';

const Information = () => (
  <div>
    <NavLink to="/informationen/imprint" className="InfoLink">
      Impressum
    </NavLink>
    <NavLink to="/informationen/about" className="InfoLink">
      Über Biwapp
    </NavLink>
    <NavLink to="/informationen/privacy" className="InfoLink">
      Datenschutzerklärung
    </NavLink>
    <NavLink to="/informationen/termsOfUse" className="InfoLink">
      Nutzungsbedingungen
    </NavLink>
    <NavLink to="/informationen/recommend" className="InfoLink">
      Weiterempfehlen
    </NavLink>
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="http://m.hochwasserzentralen.de/"
      className="InfoLink"
    >
      Pegelstände
    </a>
  </div>
);

export default Information;



// WEBPACK FOOTER //
// ./src/js/routes/Information/index.js